module.exports = __webpack_public_path__ + "media/application/images/svgs/message-square-612bd14f4c61be722f6538590bf4845b.svg";